import { render, staticRenderFns } from "./iDSToolBar.vue?vue&type=template&id=7054ba0f"
import script from "./iDSToolBar.vue?vue&type=script&lang=js"
export * from "./iDSToolBar.vue?vue&type=script&lang=js"
import style0 from "./iDSToolBar.vue?vue&type=style&index=0&id=7054ba0f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports